import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';
import { StepModel } from '../../../../models/form/step';
import { FieldModel } from '../../../../models/form/field';
import { SectionModel } from '../../../../models/form/section';
import { BuildedValues, DataFieldModels } from './FormModels';
import { FieldType } from '../../../../models/form/fieldType';
import { noop } from '../../../../utilities/FunctionUtilities';

export const formatValues = (steps: StepModel[], values: BuildedValues): any => {
  const submissionValues: any = { fields: [], files: [] };
  for (const step of steps) {
    for (const section of step.sections) {
      if (section.multiple && section.sectionsFormik) {
        let counter = 1;
        for (const aSection of section.sectionsFormik) {
          for (const field of aSection.fields) {
            if (field.visible) {
              const fieldId = field.id.split('@', 2)[0];
              if (fieldId && values[field.id] !== undefined) {
                if (field.type == FieldType.UploadFile) {
                  submissionValues.files.push({ id: fieldId, value: values[field.id] as File });
                  submissionValues.fields.push({
                    id: fieldId,
                    value: '',
                    rowId: counter,
                  });
                } else {
                  submissionValues.fields.push({
                    id: fieldId,
                    value: JSON.stringify({ value: values[field.id] }),
                    rowId: counter,
                  });
                }
              }
            }
          }
          counter += 1;
        }
      } else {
        for (const field of section.fields) {
          if (values[field.id] !== undefined && field.visible) {
            if (field.type === FieldType.UploadFile) {
              submissionValues.files.push({ id: field.id, value: values[field.id] as File });
              submissionValues.fields.push({
                id: field.id,
                value: JSON.stringify({ value: '' }),
                rowId: 1,
              });
            } else {
              submissionValues.fields.push({
                id: field.id,
                value: JSON.stringify({ value: values[field.id] }),
                rowId: 1,
              });
            }
          }
        }
      }
    }
  }
  return submissionValues;
};

export const initializeSteps = (steps: StepModel[], dataFields?: DataFieldModels): StepModel[] => {
  const buildNewSections = (numberOfTimes: number, section: SectionModel) => {
    const newSections: SectionModel[] = [];
    for (let i = 0; i < numberOfTimes; i++) {
      const sectionClone = _.cloneDeep(section);
      delete sectionClone.sectionsFormik;

      sectionClone.id = uuidv4();
      for (const field of sectionClone.fields) {
        const newId = buildFieldMultipleId(field.id, (i + 1).toString());
        field.id = newId;
      }
      newSections.push(sectionClone);
    }
    return newSections;
  };
  for (const step of steps) {
    for (const section of step.sections) {
      const dataValue = dataFields ? dataFields : undefined;
      let multipleSectionsNumber = 0;
      if (section.multiple && Array.isArray(dataValue)) {
        multipleSectionsNumber = findMultipleSectionNumber(section, dataValue);
        const newSections = buildNewSections(multipleSectionsNumber, section);
        section.sectionsFormik = newSections;
      } else if (section.multiple && section.multipleValidations && section.multipleValidations.min) {
        const newSections = buildNewSections(section.multipleValidations.min, section);
        section.sectionsFormik = newSections;
      } else {
        section.sectionsFormik = [];
      }
    }
  }
  return steps;
};

const findMultipleSectionNumber = (section: SectionModel, dataValue?: DataFieldModels): number => {
  let fieldCounter = 0;
  for (const field of section.fields) {
    const counterTemp = _.filter(dataValue, { id: field.id }).length;
    counterTemp > fieldCounter ? (fieldCounter = counterTemp) : noop;
  }
  return fieldCounter;
};

export const getFieldMultipleId = (field: FieldModel): string | undefined => field.id.split('@').pop();

export const buildFieldMultipleId = (fieldId: string, rowId: string): string => fieldId + '@' + rowId;
